export class AuthEvents {
  public static get USER_SIGNIN(): string {
    return 'user:signin';
  }

  public static get USER_SIGNUP(): string {
    return 'user:signup';
  }

  public static get USER_LOGOUT(): string {
    return 'user:logout';
  }

  public static get USER_UNAUTHORIZED(): string {
    return 'user:unauthorized';
  }
}



// WEBPACK FOOTER //
// /jenkins/jenkins/workspace/apppronosticos_install_s3_dev/src/app/core/auth/auth-events.ts